export default __webpack_public_path__ + "static/media/cta.14c0bd2b.jpg";